<div class="da-overlay" [class.saindo]="fechando" [style.padding-right.px]="larguraSacola"
     [class.dialog-mobile]="exibirComoDialogMobile()"
     (click)="fechar('overlay')">
  <div class="da-sheet" [class.mobile]="exibirComoSheet()"
       [class.dialog-mobile]="exibirComoDialogMobile()" (click)="$event.stopPropagation()">
    <div class="da-alca" *ngIf="exibirComoSheet()"></div>

    <div class="da-topo">
      <span class="da-pill">
        <span class="da-pill-icone" aria-hidden="true">🔥</span>
        Promoções de hoje
      </span>

      <div class="da-modos" *ngIf="podeAlternarModo()">
        <button type="button" class="da-modo" [class.ativo]="modoGrade"
                [attr.aria-pressed]="modoGrade" (click)="useModo(true)"
                title="Grade" aria-label="Ver em grade">
          <i class="fas fa-th-large"></i>
        </button>
        <button type="button" class="da-modo" [class.ativo]="!modoGrade"
                [attr.aria-pressed]="!modoGrade" (click)="useModo(false)"
                title="Lista" aria-label="Ver em lista">
          <i class="fas fa-bars"></i>
        </button>
      </div>

      <button type="button" class="da-fechar" (click)="fechar('fechar')" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="da-cabecalho">
      <h4 class="da-titulo">Aproveite antes de fechar o pedido</h4>
      <p class="da-subtitulo" *ngIf="economiaTotal > 0">
        Você economiza até <b class="da-economia">{{ economiaTotal | currency: 'BRL' }}</b> nos itens selecionados abaixo.
      </p>
    </div>

    <div class="da-cards" [class.grade]="modoGrade">
      <div class="da-card" *ngFor="let produto of produtos" (click)="clicouProduto(produto)">
        <div class="da-card-foto" *ngIf="temImagem(produto)">
          <img [src]="obtenhaImagem(produto)" alt="" (error)="marqueImagemComErro(produto)"/>
          <span class="da-selo" *ngIf="percentualDesconto(produto) > 0">
            -{{percentualDesconto(produto)}}%
          </span>
        </div>

        <div class="da-card-info">
          <span class="da-nome">{{produto.nome}}</span>
          <span class="da-descricao" *ngIf="produto.descricao">{{descricaoCurta(produto)}}</span>

          <div class="da-precos">
            <span class="da-apartir" *ngIf="produto.valorMinimo">a partir de</span>
            <span class="da-preco">{{ obtenhaPreco(produto) | currency: 'BRL' }}</span>

            <!-- sem foto o selo nao tem onde morar: o desconto volta para a linha do preco -->
            <span class="da-chip" *ngIf="!temImagem(produto) && percentualDesconto(produto) > 0">
              -{{percentualDesconto(produto)}}%
            </span>

            <span class="da-preco-antigo" *ngIf="produto.precoAntigo">
              {{ produto.precoAntigo | currency: 'BRL' }}
            </span>

            <button type="button" class="da-btn-add"
                    (click)="clicouProduto(produto); $event.stopPropagation()">
              <i class="fas fa-plus"></i> <span class="da-btn-rotulo">Adicionar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="da-rodape">
      <button type="button" class="da-ver-todos" (click)="clicouVerTodos()">
        Ver todas as ofertas do cardápio <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
